const colors = {
    white: '#FFFFFF',
    black: '#000000',
    whatsAppGreen: '#25D366',
    wazePrimary: '#05C8F7',
    wazeDarkBlue: '#056A82',
    instagramPink: '#D62976',
};
export default colors;
